import React from "react";
import { arrayOf, bool, string } from "prop-types";
import { Box, Chip, Typography } from "@mui/material";

const DrugList = ({
  drugs = [],
  inline = false,
  darkChips = false,
  inlineText = "",
  showTitle = true,
}) => {
  return (
    <Box sx={inline ? { display: "flex", alignItems: "baseline" } : undefined}>
      {showTitle && (
        <Typography
          sx={
            inline
              ? {
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                  fontWeight: 600,
                }
              : {
                  marginBottom: "5px",
                }
          }
        >
          {inlineText ? inlineText : "Drugs in report"}{" "}
        </Typography>
      )}
      <Box
        sx={(theme) => ({
          display: "flex",
          flexWrap: "wrap",
          [theme.breakpoints.down("md")]: {
            marginTop: 1,
          },
        })}
      >
        {drugs.map((d, i) => (
          <Chip
            label={d.trim()}
            key={`related-drug-${i}`}
            sx={(theme) => ({
              marginRight: "4px",
              marginTop: "4px",
              marginBottom: "4px",
              ...(darkChips && {
                background: "#f5f5f5",
              }),
              [theme.breakpoints.down("md")]: {
                background: "none",
                height: "auto",
                "&:not(:last-of-type) :after": {
                  content: '","',
                  display: "inline",
                },
                "& .MuiChip-label": {
                  padding: 0,
                },
              },
            })}
          />
        ))}
      </Box>
    </Box>
  );
};

DrugList.propTypes = {
  drugs: arrayOf(string),
  inline: bool,
  darkChips: bool,
  inlineText: string,
  showTitle: bool,
};

export default DrugList;
